import { MILITAO_URL } from '@/config'
import { removeDoubleSlashes } from '@/utils'

export * from './getPath'

export const getUrl = (path: string) =>
  removeDoubleSlashes(`${MILITAO_URL}/${path}`)

export const redirectTo = (url: string) => {
  window.location.href = url
}
